import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-benthin-system',
  templateUrl: './benthin-system.component.html',
  styleUrls: ['./benthin-system.component.scss']
})
export class BenthinSystemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
